import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { PricesService } from "../../_services/prices.service";
import { ToasterService } from '../../_services/toaster.service';

declare var $: any;

@Component({
  selector: 'app-couponcodelist',
  templateUrl: './couponcodelist.component.html',
  styleUrls: ['./couponcodelist.component.css']
})
export class CouponcodelistComponent implements OnInit {

  userdetaild: string;
  returnUrl: string;
  promoCodeList: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute,private toaster: ToasterService, private pricesService: PricesService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getCodeCodeList();

  }

  getCodeCodeList() {
    this.pricesService.getCodeCodeList()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.promoCodeList = data.promoCodeList;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);

          } else {
            this.toaster.showError('promoCodeList', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
        },
        error => {
          this.toaster.showError('promoCodeList', error);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deletePromoCode(id) {
    if(confirm("Are you sure to delete ")) {
    const payload = {id: id};
    this.pricesService.deleteCouponCode(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.getCodeCodeList();
            this.toaster.showSuccess('promoCodeList', data.ResponseMessage);
          } else {
            this.toaster.showError('promoCodeList', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('promoCodeList', error.error.ResponseMessage);
        });
      }
  }


}
